/**
 * Страница пользователя: детали проекта (user/projectdetail).
 *
 * Маркер инициализации — форма #projectInfoForm.
 * Без конфига (Blade-переменных в скрипте не было).
 *
 * Функционал:
 *   - отслеживание изменений полей (подсветка + активация кнопки SAVE);
 *   - удобный формат поля бюджета (€ префикс);
 *   - валидация обязательного PROJECT NAME при submit.
 */

function init() {
    if (!document.getElementById('projectInfoForm')) return;

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[project-detail] jQuery not loaded');
        return;
    }
    const showToast = window.showToast || function () {};

    $(() => {
        const $form = $('#projectInfoForm');
        const $saveBtn = $('#saveProjectBtn');
        const originalFormData = {};

        function saveOriginalFormData() {
            $form.find('input, textarea').each(function () {
                originalFormData[$(this).attr('name')] = $(this).val();
            });
        }

        function checkFormChanges() {
            let hasChanges = false;
            $form.find('input, textarea').each(function () {
                const $field = $(this);
                const name = $field.attr('name');
                if ($field.val() !== originalFormData[name]) {
                    hasChanges = true;
                    $field.addClass('changed');
                } else {
                    $field.removeClass('changed');
                }
            });
            $saveBtn.prop('disabled', !hasChanges);
        }

        saveOriginalFormData();
        $form.on('input change', 'input, textarea', checkFormChanges);

        // MNY-171: переключатель «делиться скидкой с клиентом» (две кнопки + hidden input)
        const $discountInput = $('#share_discount_with_client');
        const $discountBtns = $('.discount-toggle-btn');

        function syncDiscountToggle() {
            const current = $discountInput.val();
            $discountBtns.each(function () {
                $(this).toggleClass('active', String($(this).data('value')) === current);
            });
        }

        if ($discountInput.length) {
            syncDiscountToggle();
            $discountBtns.on('click', function () {
                // change событие подхватит checkFormChanges → активирует SAVE
                $discountInput.val(String($(this).data('value'))).trigger('change');
                syncDiscountToggle();
            });
        }

        // Префикс "€ " в поле budget
        $('#budget')
            .on('focus', function () {
                const val = $(this).val();
                if (val.startsWith('€ ')) $(this).val(val.substring(2));
            })
            .on('blur', function () {
                const val = $(this).val().trim();
                if (val && !val.startsWith('€')) $(this).val('€ ' + val);
            });

        $form.on('submit', function (e) {
            const projectName = $('#project_name').val().trim();
            if (!projectName) {
                e.preventDefault();
                showToast('error', 'Project name is required');
                $('#project_name').focus();
                return false;
            }

            const budgetValue = $('#budget').val();
            if (budgetValue && budgetValue.startsWith('€ ')) {
                $('#budget').val(budgetValue.substring(2).trim());
            }
            return true;
        });

        $form.on('focus', '.input-error', function () {
            $(this).removeClass('input-error');
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
